import { constants, Header, PageSection, ProductNav, } from '@redbubble/design-system';
import { ExperimentConfig } from '@redbubble/next-amplitude';
import { onSearchCallback, onTypeaheadResultClick, } from '@redbubble/next-analytics/gtm';
import { useAmplitudeExperiment } from '@redbubble/next-provider/amplitude';
import { RSLinkClickedLocation, useRudderstackClient, } from '@redbubble/next-provider/rudderstack';
import { useRouter } from 'next/router';
import React from 'react';
import { trackGA4GlobalNavViewCategory, trackGA4GlobalNavViewSubCategory, } from '../analytics';
import { CartItemsCount } from '../cart-items-count';
import { TopicNav } from './TopicNav/TopicNav';
import { buildTopicNavConfig } from './TopicNav/topicNavConfig';
import { useTopicNavConfig } from './TopicNav/useTopicNavConfig';
function TopicNavWithConfig(_a) {
    var intl = _a.intl, onEvent = _a.onEvent;
    var asPath = useRouter().asPath;
    var rawConfig = buildTopicNavConfig(intl.formatMessage);
    var config = useTopicNavConfig(asPath, rawConfig);
    return React.createElement(TopicNav, { config: config, onEvent: onEvent });
}
var getPromoBannerHeight = function (bannerMessages, profile) {
    if (!bannerMessages || bannerMessages.length === 0)
        return 0;
    return profile === constants.DESKTOP ? 48 : 80;
};
export var AppHeader = function (_a) {
    // We have to determine device from the user-agent header and not viewport width
    // otherwise there can be mismatches between actual device type and that which would
    // be returned from useViewportWidth hook.
    // This is because when a client has a 768px viewport width doesnt mean it will be a tablet
    // when determined from useragent. iPads provide a desktop mac user-agent unless
    // specifically set otherwise.
    var headAndFooterVariant = _a.headAndFooterVariant, forceMobileHeader = _a.forceMobileHeader, intl = _a.intl, userInfo = _a.userInfo, globalNavigation = _a.globalNavigation, bannerMessages = _a.bannerMessages, deviceType = _a.deviceType, disableExpandedMobileSearch = _a.disableExpandedMobileSearch, disableStickySearch = _a.disableStickySearch, engagingPlaceholderMessages = _a.engagingPlaceholderMessages, searchTerm = _a.searchTerm, searchProductContext = _a.searchProductContext, type = _a.type, _b = _a.hideProductNavigation, hideProductNavigation = _b === void 0 ? false : _b, _c = _a.showAnimatedLogo, showAnimatedLogo = _c === void 0 ? true : _c, _d = _a.bannerInitialSeconds, bannerInitialSeconds = _d === void 0 ? 0 : _d;
    // TODO: Remove this as soon as possible we should not be rendering different components based on user-agent
    var shouldUseMobileHeader = deviceType === 'mobile' || deviceType === 'tablet' || forceMobileHeader;
    var navTopicsVariant = useAmplitudeExperiment(ExperimentConfig.NavTopicsInternal);
    var isTopicsTreatment = navTopicsVariant === 'treatment';
    var renderProductNav = deviceType === 'desktop' && !hideProductNavigation && !isTopicsTreatment;
    var profile = shouldUseMobileHeader ? constants.MOBILE : constants.DESKTOP;
    var showExpandedMobileSearch = !disableExpandedMobileSearch && shouldUseMobileHeader;
    var headerPosition = !disableStickySearch ? 'fixed' : 'relative';
    var promoBannerHeight = getPromoBannerHeight(bannerMessages, profile);
    var RudderstackClient = useRudderstackClient().RudderstackClient;
    var handleTopicNavEvent = function (event) {
        if (deviceType !== 'desktop')
            return;
        if (RudderstackClient) {
            RudderstackClient.linkClicked({
                link_label: event.link_label,
                location: RSLinkClickedLocation.NavSub,
            });
        }
    };
    return (React.createElement("header", null,
        React.createElement(CartItemsCount, { initialCount: userInfo === null || userInfo === void 0 ? void 0 : userInfo.cartItems }, function (cart) { return (React.createElement("div", { className: isTopicsTreatment ? 'rb-topics-header' : undefined },
            React.createElement(Header, { cart: cart, globalNavigation: globalNavigation, intl: intl, isServer: typeof window === 'undefined', profile: profile, userInfo: userInfo, useRainbowStyle: true, engagingPlaceholderMessages: engagingPlaceholderMessages, showExpandedMobileSearch: showExpandedMobileSearch, showHamburgerOnDesktop: isTopicsTreatment, position: headerPosition, searchTerm: searchTerm, bannerMessages: bannerMessages, initialSeconds: bannerInitialSeconds, searchProductContext: searchProductContext, onTypeaheadResultClick: onTypeaheadResultClick, onSearchCallback: onSearchCallback, onNavItemClick: function (item, rootItem) {
                    trackGA4GlobalNavViewSubCategory(item, {
                        position: 'left_side',
                        parent: rootItem.label,
                    });
                    if (!RudderstackClient)
                        return;
                    RudderstackClient.linkClicked({
                        link_label: item.label,
                        location: RSLinkClickedLocation.NavSub,
                    });
                }, onNavItemView: function (item) {
                    return trackGA4GlobalNavViewCategory(item, {
                        position: 'left_side',
                    });
                }, type: type, showAnimatedLogo: showAnimatedLogo }))); }),
        isTopicsTreatment && (React.createElement(PageSection, null,
            React.createElement(TopicNavWithConfig, { intl: intl, onEvent: handleTopicNavEvent }))),
        renderProductNav && (React.createElement(ProductNav, { intl: intl, items: globalNavigation, peeking: true, promoBannerHeight: promoBannerHeight, onNavItemClick: function (item, rootItem) {
                trackGA4GlobalNavViewSubCategory(item, {
                    position: 'header',
                    parent: rootItem === null || rootItem === void 0 ? void 0 : rootItem.label,
                });
                if (!RudderstackClient)
                    return;
                RudderstackClient.linkClicked({
                    link_label: item.label,
                    location: RSLinkClickedLocation.NavSub,
                });
            } }))));
};
